export default "__VITE_ASSET__ClvZ0_8p__"